import { observer } from 'mobx-react-lite'
import { InventoryItemFormContainer } from '@/features/inventory/admin/components/InventoryItemForm/InventoryItemFormContainer'
import { type CreateInventoryItemDialogViewModel } from './CreateInventoryItemDialogViewModel'

export interface CreateInventoryItemDialogContainerProps {
  vm: CreateInventoryItemDialogViewModel
}

export const CreateInventoryItemDialogContainer = observer(
  function CreateInventoryItemDialogContainer({
    vm,
  }: CreateInventoryItemDialogContainerProps) {
    return (
      <InventoryItemFormContainer
        vm={vm}
        title="Add global service item"
        submitText="Add new"
      />
    )
  },
)
